import React, { useState, useRef, useEffect } from 'react';

const MyComponent = () => {
  const [activeItems, setActiveItems] = useState({});
  const itemRefs = useRef({});

  // Xử lý click vào tiêu đề
  const handleTitleClick = (index, e) => {
    e.preventDefault();
    
    // Toggle class xanh và trạng thái active
    setActiveItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));

    // Scroll to top của phần tử
    if (itemRefs.current[index]) {
      const topPosition = itemRefs.current[index].offsetTop;
      window.scrollTo({
        top: topPosition,
        behavior: 'smooth'
      });
    }
  };

  // Xử lý fancybox cho ảnh (cần cài đặt thư viện react-fancybox hoặc tương tự)
  useEffect(() => {
    // Khởi tạo fancybox nếu có
    // Ví dụ với react-fancybox:
    // import FancyBox from 'react-fancybox';
    // Sử dụng component FancyBox bao quanh ảnh
  }, []);

  return (
    <div>
      {/* Ví dụ về cấu trúc HTML tương ứng */}
      {[1, 2, 3].map((item, index) => (
        <div key={index} ref={el => itemRefs.current[index] = el}>
          <h3 
            className={`tieudekhoi ${activeItems[index] ? 'xanh' : ''}`}
            onClick={(e) => handleTitleClick(index, e)}
            style={{ cursor: 'pointer' }}
          >
            Tiêu đề {item}
          </h3>
          
          <div 
            className="noidungkhoi"
            style={{
              display: activeItems[index] ? 'block' : 'none',
              transition: 'all 0.5s ease-in-out'
            }}
          >
            Nội dung {item}
            
            {/* Ví dụ về ảnh với fancybox */}
            <div className="vaicaianh">
              <a href="/path-to-large-image.jpg" data-fancybox="gallery">
                <img src="/path-to-thumbnail.jpg" alt="Example" />
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MyComponent;